"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataStore = (function () {
    function DataStore(json) {
        this.json = json;
    }
    DataStore.prototype.getAllCampuses = function () {
        return this.json.campuses;
    };
    DataStore.prototype.getAllStates = function () {
        var states = this.json.states;
        return states.map(function (s) {
            return { value: s.name, label: s.name };
        });
    };
    DataStore.prototype.campusesHasOnlineProgram = function (campuses, programCode) {
        for (var _i = 0, campuses_1 = campuses; _i < campuses_1.length; _i++) {
            var item = campuses_1[_i];
            var campusObject = this.getCampusObjectByCode(item);
            if (!campusObject) {
                continue;
            }
            if (campusObject.onlinePrograms.indexOf(programCode) === -1) {
                return false;
            }
        }
        return true;
    };
    DataStore.prototype.campusHasGroundProgram = function (campusCode, programCode) {
        var campusObject = this.getCampusObjectByCode(campusCode);
        if (!campusObject) {
            return false;
        }
        if (campusObject.groundPrograms.indexOf(programCode) === -1) {
            return false;
        }
        return true;
    };
    DataStore.prototype.getAdvisorsArray = function (campusName) {
        var json = this.json;
        if (json.campuses) {
            for (var i = 0; i < json.campuses.length; i++) {
                if (json.campuses[i].name == campusName) {
                    return json.campuses[i].advisors;
                }
            }
        }
        console.log("Warning! No advisers found for campus=" + campusName);
        return null;
    };
    DataStore.prototype.getCampusObject = function (campusName) {
        var json = this.json;
        if (json.campuses) {
            for (var i = 0; i < json.campuses.length; i++) {
                if (json.campuses[i].name == campusName) {
                    return json.campuses[i];
                }
            }
        }
        console.log("Warning! No campus found for campusName=" + campusName);
        return null;
    };
    DataStore.prototype.getCampusObjectByCode = function (campusCode) {
        var json = this.json;
        if (json.campuses) {
            for (var i = 0; i < json.campuses.length; i++) {
                if (json.campuses[i].code == campusCode) {
                    return json.campuses[i];
                }
            }
        }
        console.log("Warning! No campus found for campusCode=" + campusCode);
        return null;
    };
    DataStore.prototype.getProgramObjectByCode = function (code) {
        var json = this.json;
        if (json.programs) {
            for (var i = 0; i < json.programs.length; i++) {
                if (json.programs[i].code == code) {
                    return json.programs[i];
                }
            }
        }
        console.log("Warning! No program found for code=" + code);
        return null;
    };
    DataStore.prototype.getProgramObjectByName = function (name) {
        var json = this.json;
        if (json.programs) {
            for (var i = 0; i < json.programs.length; i++) {
                if (json.programs[i].name == name) {
                    return json.programs[i];
                }
            }
        }
        console.log("Warning! No program found for name=" + name);
        return null;
    };
    DataStore.prototype.getCampusPrograms = function (campusName) {
        var campus = this.getCampusObject(campusName);
        if (!campus) {
            return null;
        }
        var online = campus.onlinePrograms;
        var ground = campus.groundPrograms;
        var all = online.concat(ground);
        var unique = all.filter(this.onlyUnique);
        var programs = [];
        for (var _i = 0, unique_1 = unique; _i < unique_1.length; _i++) {
            var code = unique_1[_i];
            var programObject = this.getProgramObjectByCode(code);
            programs.push(programObject.name);
        }
        programs.sort(function (a, b) {
            if (a < b)
                return -1;
            if (a > b)
                return 1;
            return 0;
        });
        return programs;
    };
    DataStore.prototype.getAllPrograms = function () {
        var json = this.json;
        var programs = [];
        if (json.programs) {
            programs = json.programs;
            programs.sort(function (a, b) {
                if (a.name < b.name)
                    return -1;
                if (a.name > b.name)
                    return 1;
                return 0;
            });
        }
        return programs;
    };
    DataStore.prototype.getCampusesForProgram = function (programName) {
        var json = this.json;
        var campuses = [];
        if (json.programs) {
            var program = json.programs.filter(function (p) { return p.name == programName; })[0];
            if (program) {
                if (json.campuses) {
                    for (var i = 0; i < json.campuses.length; i++) {
                        if (json.campuses[i].onlinePrograms.indexOf(program.code) > -1 ||
                            json.campuses[i].groundPrograms.indexOf(program.code) > -1) {
                            campuses.push(json.campuses[i]);
                        }
                    }
                }
            }
        }
        campuses.sort(function (a, b) {
            if (a.name < b.name)
                return -1;
            if (a.name > b.name)
                return 1;
            return 0;
        });
        return campuses;
    };
    DataStore.prototype.onlyUnique = function (value, index, self) {
        return self.indexOf(value) === index;
    };
    DataStore.prototype.getStartDates = function () {
        return [
            { value: "", label: "-- select an option --" },
            { value: "Undecided", label: "Undecided" },
            { value: "April 19, 2020", label: "April 19, 2020" },
            { value: "May 24, 2020", label: "May 24, 2020" },
            { value: "July 5, 2020", label: "July 5, 2020" },
            { value: "August 9, 2020", label: "August 9, 2020" },
            { value: "September 20, 2020", label: "September 20, 2020" },
            { value: "October 25, 2020", label: "October 25, 2020" },
            { value: "November 6, 2020", label: "November 6, 2020" }
        ];
    };
    DataStore.prototype.getClassTimes = function () {
        return [
            {
                value: "undecided",
                label: "Undecided"
            },
            {
                value: "online",
                label: "Online (for students who take 100% online classes)"
            },
            {
                value: "GL - Days",
                label: "GL - Days (students who take day classes or Global Learning During the Day)"
            },
            {
                value: "GL - Nights",
                label: "GL - Nights (students who take night classes or Global Learning during the night session)"
            }
        ];
    };
    Object.defineProperty(DataStore.prototype, "marital_status", {
        get: function () {
            return [
                { value: "Married", label: "Married" },
                { value: "Single", label: "Single" },
                { value: "Divorced", label: "Divorced" },
                { value: "Widow", label: "Widow" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "gender", {
        get: function () {
            return [
                { value: "Male", label: "Male" },
                { value: "Female", label: "Female" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "education_equivalent", {
        get: function () {
            var arr = [
                "I passed all applicable Standards of Learning exams and received a High School Diploma",
                "I am currently attending High School and expect to pass all applicable Standards of Learning exams and receive a Diploma",
                "I completed High School and received a Certificate of Attendance and earned a GED",
                "I completed High School and received a Certificate of Attendance and passed a state-authorized examination that the state recognized as the equivalent of a high School Diploma",
                "I completed High School in a home-school setting",
                "I did not complete High School, but I earned a GED",
                "I did not complete High School, but passed a state-authorized examination that the state recognized as the equivalent of a high School Diploma"
            ];
            return arr.map(function (item) {
                return { value: item, label: item };
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "student_athlete", {
        get: function () {
            return [{ value: "basketball", label: "Men’s Basketball" }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "races", {
        get: function () {
            return [
                { value: "White", label: "White" },
                { value: "Hispanic/Latino", label: "Hispanic/Latino" },
                { value: "American Indian/Alaska Native", label: "American Indian/Alaska Native" },
                { value: "Asian", label: "Asian" },
                { value: "Black/African American", label: "Black/African American" },
                { value: "Native Hawaiian/Pacific Islander", label: "Native Hawaiian/Pacific Islander" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "programs", {
        get: function () {
            return [
                { value: "Cosmetology", label: "Cosmetology" },
                { value: "Nails", label: "Nails" },
                { value: "Esthetics", label: "Esthetics" },
                { value: "Instructor Training", label: "Instructor Training" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "payment", {
        get: function () {
            return [
                { value: "Payment in full", label: "Payment in full" },
                { value: "Plan #1", label: "Plan #1" },
                { value: "Plan #2", label: "Plan #2" },
                { value: "Financial Aid", label: "Financial Aid" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "applicationsStatus", {
        get: function () {
            return [
                { value: "New Applicant", label: "New Applicant" },
                { value: "Transfer Student", label: "Transfer Student" },
                { value: "Former EFA Student", label: "Former EFA Student" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "incomes", {
        get: function () {
            return [
                { value: "$0-$30,000", label: "$0-$30,000" },
                { value: "$30,001-$48,000", label: "$30,001-$48,000" },
                { value: "$48,001-$75,000", label: "$48,001-$75,000" },
                { value: "$75,001-$110,000", label: "$75,001-$110,000" },
                { value: "$110,001 and up", label: "$110,001 and up" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "arrangements", {
        get: function () {
            return [
                { value: "Off campus with parents/family", label: "Off campus with parents/family" },
                {
                    value: "Off campus not with parents/family",
                    label: "Off campus not with parents/family"
                }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "measures", {
        get: function () {
            return [
                { value: "Extra Small (0-2)", label: "Extra Small (0-2)" },
                { value: "Small (2-4)", label: "Small (2-4)" },
                { value: "Medium (6-8)", label: "Medium (6-8)" },
                { value: "Large (10-12)", label: "Large (10-12)" },
                { value: "Extra Large (14-16)", label: "Extra Large (14-16)" },
                { value: "2X Large (18-20)", label: "2X Large (18-20)" },
                { value: "3X Large (22+)", label: "3X Large (22+)" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "hearAboutUs", {
        get: function () {
            return [
                { value: "Youtube", label: "Youtube" },
                { value: "Google", label: "Google" },
                { value: "Facebook", label: "Facebook" },
                { value: "Twitter", label: "Twitter" },
                { value: "Instagram", label: "Instagram" },
                { value: "Email", label: "Email" },
                { value: "TV", label: "TV" },
                { value: "Newspaper", label: "Newspaper" },
                { value: "Other", label: "Other" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "fees", {
        get: function () {
            return [
                {
                    value: "Registration Fee All - $100",
                    label: "Registration Fee (All classes except Esthetics) $100.00"
                },
                {
                    value: "Registration Fee Esthetics - $200",
                    label: "Registration Fee - Esthetics $200.00"
                }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "quarter", {
        get: function () {
            return [
                {
                    value: "January",
                    label: "January"
                },
                {
                    value: "April",
                    label: "April"
                },
                {
                    value: "July",
                    label: "July"
                },
                {
                    value: "October",
                    label: "October"
                }
            ];
        },
        enumerable: true,
        configurable: true
    });
    return DataStore;
}());
exports.DataStore = DataStore;
//# sourceMappingURL=data:application/json;base64,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